/* eslint-disable import/no-mutable-exports */
import calculateSize from 'calculate-size';
import React, { useState, useEffect } from 'react';
import Button from '../../@base/Button';
import ConditionPart from './DialogNodeConditionPart';
import styles from './DialogNode.module.css';

export let allIntents = [];
export let allEntities = [];

export const calculeWidth = (value) => {
  const width = calculateSize(value, {
    font: 'Rawline',
    fontSize: '13px',
  });
  return width.width + 17;
};

/** Controle das condições de reconhecimento do dialogo */
const DialogNodeCondition = (props) => {
  if (!props.condition || !props.condition.object) return <></>;

  const [condition, setCondition] = useState(props.condition);

  allIntents = Object.values(props.intents).map((i) => ({ id: i.id, name: i.name }));
  allEntities = Object.values(props.entities).map((i) => ({
    id: i.id,
    name: i.name,
    values: i.values,
  }));

  const commonProps = {
    condition,
    setCondition,
  };

  useEffect(() => {
    if (condition) {
      const conditionChanged = JSON.stringify(condition) !== JSON.stringify(props.condition);
      if (conditionChanged) props.updateCondition(condition);
    }
  }, [condition]);

  useEffect(() => {
    setCondition(props.condition);
  }, [props.condition]);

  return (
    <div className="item-list dialog-condition">
      <div className={styles.ConditionItem}>
        <ConditionPart
          id="relationalOperator"
          {...commonProps}
          firstCondition={props.firstCondition}
          notRender={props.justOneCondition}
        />
        <ConditionPart
          id="type"
          {...commonProps}
        />
        <ConditionPart
          id="object"
          {...commonProps}
        />
        <ConditionPart
          id="logicalOperator"
          {...commonProps}
        />
        <ConditionPart
          id="comparedValue"
          {...commonProps}
        />
      </div>

      <Button
        small
        circle
        disabled={props.removeDisabled}
        onClick={props.removeCondition}
      >
        <span><i className="fa fa-times" aria-hidden="true" /></span>
      </Button>
    </div>
  );
};

export default DialogNodeCondition;
